import { useRoutes } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import { queryClient } from './config/query-client';
import { routes } from './routes';
import { muiTheme } from './theme/mui-theme';

export default function App() {
  const element = useRoutes(routes);

  return (
    <ThemeProvider theme={muiTheme}>
      <QueryClientProvider client={queryClient}>{element}</QueryClientProvider>
    </ThemeProvider>
  );
}
